import React, { forwardRef, SVGProps, memo } from 'react';
import { IconName, ICON_MAP } from './Icon/IconName';

type IconProps = SVGProps<SVGSVGElement> & {
  name: IconName;
  children?: never;
  title?: string;
  size?: number;
};

export const Icon = memo(forwardRef<SVGSVGElement, IconProps>(function Icon({ name, title, size = 24, ...props }, ref) {
  const PredefinedIcon = ICON_MAP[name.toLowerCase()];

  if (!PredefinedIcon) {
    if (process.env.NODE_ENV === 'development') throw new Error(`Failed to render Icon. Unable to find svg matching name ${name}.`);

    return null;
  }

  return (
    <PredefinedIcon
      role={title ? 'img' : 'presentation'} // so that the SVG is not traversed by browsers that map the SVG to the group role
      preserveAspectRatio="xMidYMin meet"
      aria-hidden={Boolean(title)}
      aria-label={title}
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width={size}
      height={size}
      ref={ref}
      {...props}
    />
  );
}));
